/**
 * Single-flight chat session create for one SmartChat instance.
 *
 * Mount-time creates race with React Strict Mode (dev remount) and with double
 * submits; callers share one in-flight promise so a conversation gets one session.
 */
export type SessionSlot = {
  id: string | null;
  inflight: Promise<string> | null;
};

export function ensureChatSession(
  slot: SessionSlot,
  create: () => Promise<{ id: string }>,
): Promise<string> {
  if (slot.id) return Promise.resolve(slot.id);
  if (slot.inflight) return slot.inflight;

  const pending = create()
    .then((session) => {
      slot.id = session.id;
      return session.id;
    })
    .finally(() => {
      if (slot.inflight === pending) slot.inflight = null;
    });

  slot.inflight = pending;
  return pending;
}
